import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CartModel, TransactionModel } from '../models/profile.model';
import firebase from 'firebase';
import { environment } from '../environment/environment';

@Injectable()
export class BillingProvider {

  backendURL = environment.backendURL;

  constructor(
    private http: HttpClient
  ) { }

  async convertCurrency(to, from, amount) {

    let data = {
      to: to,
      from: from,
      amount: amount
    };

    let token;

    await firebase.auth().currentUser.getIdToken(true).then(idToken => {
      token = idToken;
    }).catch(error => {
      return Promise.reject(error);
    });

    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': token
      })
    };

    return new Promise((resolve, reject) => {

      this.http.post((this.backendURL + 'convertCurrency'), data, httpOptions)
        .subscribe((res) => {

          if (res['result'] == 'success')
            return resolve(res);
        })
    });
  }

  async billGuest(token, price) {

    let authToken;

    await firebase.auth().currentUser.getIdToken(true).then(idToken => {
      authToken = idToken;
    }).catch(error => {
      return Promise.reject(error);
    });

    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': authToken
      })
    };

    this.http.post((this.backendURL + 'processpay'),
      { stripetoken: token, amount: price }, httpOptions)
      .subscribe((res) => {

        if (res['result'] == 'success')
          alert('transaction Successfull!!')
      })
  }

  async createCustomer(source, email) {

    let data = {
      source: source,
      email: email
    };

    let token;

    await firebase.auth().currentUser.getIdToken(true).then(idToken => {
      token = idToken;
    }).catch(error => {
      return Promise.reject(error);
    });

    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': token
      })
    };

    return new Promise((resolve, reject) => {

      this.http.post((this.backendURL + 'createCustomer'), data, httpOptions)
        .subscribe((res) => {
          if (res['customerId'])
            return resolve(res);
          else
            return reject();
        }, (error) => {
          return reject(error);
        });
    });

  }

  async billCustomer(customerId, currency, transDescription, price, email) {

    // Amout should always be passed in the smallest unit of the currency
    // For USD amount should be in cents
    price = this.convertPayableAmountToSmallestUnit(price, currency);

    let data = {
      customerId: customerId,
      currency: currency,
      description: transDescription,
      amount: price,
      email: email
    };
    let token;

    await firebase.auth().currentUser.getIdToken(true).then(idToken => {
      token = idToken;
    }).catch(error => {
      return Promise.reject(error);
    });

    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': token
      })
    };

    return new Promise((resolve, reject) => {

      this.http.post((this.backendURL + 'processpayCustomer'), data, httpOptions)
        .subscribe((res) => {

          if (res['result'] == 'success')
            return resolve(res);
        })
    });
  }

  convertPayableAmountToSmallestUnit(amount, currency): number {

    if (currency == "usd") {
      return Math.round(amount * 100);
    }
    return Math.round(amount * 100);
  }

  async billWithTokens(uid, currency, transDescription, price, email, tribalTokenBalance) {

    let data = {
      uid: uid,
      currency: currency,
      description: transDescription,
      amount: price,
      email: email,
      tribalTokenBalance: tribalTokenBalance
    };
    let token;

    await firebase.auth().currentUser.getIdToken(true).then(idToken => {
      token = idToken;
    }).catch(error => {
      return Promise.reject(error);
    });

    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': token
      })
    };

    return new Promise((resolve, reject) => {

      this.http.post((this.backendURL + 'payWithTokens'), data, httpOptions)
        .subscribe((res) => {
          if (res['result'] == 'success')
            return resolve(res);
        })
    });
  }

  completeTransaction(transId, cartModel, type, refferalCode?) {

    var uid = firebase.auth().currentUser.uid;
    var emptyCart = new CartModel();

    var transObj = new TransactionModel(cartModel, transId, type, refferalCode);

    return new Promise((resolve, reject) => {

      firebase.database().ref('/users/' + uid + '/transactionHistory')
        .child(transId)
        .set(transObj).then(() => {

          firebase.database().ref('/users/' + uid).child('cart').set(emptyCart);

          this.updateInventory(cartModel);

          return resolve();
        }).catch(error => {
          return reject()
        });
    })
  }

  completeTribalCreditTransaction(transId, cartModel, type) {

    var uid = firebase.auth().currentUser.uid;
    var transObj = new TransactionModel(cartModel, transId, type);
    delete transObj.trackObj;
    transObj.status = "completed";

    return new Promise((resolve, reject) => {

      firebase.database().ref('/users/' + uid + '/transactionHistory')
        .child(transId)
        .set(transObj).then(() => {

          this.updateInventory(cartModel);

          return resolve();
        }).catch(error => {
          return reject()
        });
    })
  }

  async updateInventory(cartModel: CartModel) {

      let data = {
        cart: cartModel,
        uid: firebase.auth().currentUser.uid
      };

      let token;

      await firebase.auth().currentUser.getIdToken(true).then(idToken => {
        token = idToken;
      }).catch(error => {
        return Promise.reject(error);
      });

      let httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': token
        })
      };

      this.http.post((this.backendURL + 'updateProducts'), data, httpOptions).subscribe((res) => {
        
      });
  }
}


// WEBPACK FOOTER //
// ./src/services/billing.service.ts